// Module
var code = "<p>Referrers represent the webpage that a user was on before clicking a link to navigate to the current webpage, essentially the source of the traffic to a particular site; it&#39;s essentially the URL of the previous page that directed the user to the current one.</p> <p>For example: <code>localhost:8080</code></p> ";
// Exports
export default code;